import { STORAGE_URL, SystemFolder } from 'commons/constants/KeyFlowConstants';
import KeyFlowVO from 'commons/vo/KeyFlowVO';
import { assetWithOutToken, assetWithToken } from 'commons/utils/commonUtil';
import HostFactory from 'commons/handler/HostFactory';
import { API } from 'commons/constants/KeyFlowAPI';

interface TeamVOProps {
  ID: number;
  NAME: string;
  HOMETOWN: string;
  TEAM_LOGO: string;
  TEAM_COLOR: string;
  PERSON_LIST: any[];
  IS_DELETED: number;
  DATE_OF_CREATED: string;
  CREATE_USER: string;
  DATE_OF_MODIFIED: string;
}

class TeamVO extends KeyFlowVO {
  id: number;
  name: string;
  hometown: string;
  teamLogo: string;
  teamColor: string;
  personList: any[];
  isDeleted: number;
  dateOfCreated: string;
  createUser: string;
  dateOfModified: string;

  constructor(data: TeamVOProps) {
    super(data);
    this.id = data.ID;
    this.name = data.NAME;
    this.hometown = data.HOMETOWN;
    this.teamLogo = data.TEAM_LOGO;
    this.teamColor = data.TEAM_COLOR;
    this.personList = data.PERSON_LIST;
    this.isDeleted = data.IS_DELETED;
    this.dateOfCreated = data.DATE_OF_CREATED;
    this.createUser = data.CREATE_USER;
    this.dateOfModified = data.DATE_OF_MODIFIED;
  }

  getTeamLogoPath(symbolicPath: string) {
    const url = `${STORAGE_URL}${symbolicPath}/${SystemFolder.LOGO_NAME}/${this.teamLogo}`;
    return assetWithToken(url);
  }

  getTeamLogoDbPath() {
    return assetWithOutToken(`${HostFactory.apiURL}${API.TEAM_LOGO}/${this.id}`);
  }

  getTeamLogoCloudfrontPath() {
    return `${HostFactory.cloudfrontURL}/${SystemFolder.LOGO_NAME}/${this.teamLogo}`;
  }
}

export default TeamVO;
